/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconGenderGenderless = createReactComponent("outline", "gender-genderless", "IconGenderGenderless", [["path", { "d": "M12 10a5 5 0 1 1 0 10a5 5 0 0 1 0 -10z", "key": "svg-0" }], ["path", { "d": "M12 10v-7", "key": "svg-1" }], ["path", { "d": "M7 15h10", "key": "svg-2" }]]);

export { IconGenderGenderless as default };
//# sourceMappingURL=IconGenderGenderless.mjs.map
